import "owl.carousel"

export default {
  init() {
    // JavaScript to be fired on all pages

    const rem = 16

    $(".flooring-carousel").owlCarousel({
      loop: false,
      nav: false,
      margin: 1 * rem,
      stagePadding: 2 * rem,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
        },
        576: {
          items: 2,
        },
        768: {
          items: 2,
        },
        992: {
          items: 3,
          margin: 2 * rem,
        },
        1200: {
          items: 3,
          margin: 2 * rem,
        },
      },
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js